import http from "../http-common";

class ClientPaymentService {
  getAll() {
    return http.get("/client-payments");
  }

  get(id) {
    return http.get(`/client-payments/${id}`);
  }

  getByClient(clientId) {
    return http.get(`/client-payments/client/${clientId}`);
  }

  create(data) {
    return http.post("/client-payments", data);
  }

  update(id, data) {
    return http.put(`/client-payments/${id}`, data);
  }

  delete(id) {
    return http.delete(`/client-payments/${id}`);
  }
}

export default new ClientPaymentService();
